module.exports = __webpack_public_path__ + "static/media/govcc.38e10f06.png";